export var QuizPageStrings = {
    pageTitle: {
        shortQuiz: function () { return 'Take a short quiz to identify the right solution for you'; },
        recommendation: function () { return 'DoorDash for Work Solutions'; },
    },
    subtitle: {
        recommendation: function () { return 'Meals for every business occasion'; },
    },
    actionButton: {
        continue: function () { return 'Continue'; },
        finish: function () { return 'Finish'; },
        startOver: function () { return 'Start Over'; },
    },
    questions: {
        whereIsTeam: {
            question: function () { return 'Where is your team having meals?'; },
            option1: {
                title: function () { return 'Remote'; },
                subtitle: function () { return 'Distributed home offices'; },
            },
            option2: {
                title: function () { return 'In Office / Hybrid'; },
                subtitle: function () {
                    return 'Centrally located in offices, or a mix of remote and in offices';
                },
            },
        },
        howToOrder: {
            question: function () { return 'How would you like to provide meals?'; },
            option1: {
                title: function () { return 'Everyone orders for themselves'; },
            },
            option2: {
                title: function () { return 'My team orders together'; },
            },
        },
        howOften: {
            question: function () { return 'How often would you like to provide meals?'; },
            option1: {
                title: function () { return 'Just one time'; },
            },
            option2: {
                title: function () { return 'Regularly'; },
            },
        },
        workEmail: {
            question: function () { return 'What is your work email?'; },
            label: function () { return 'Your Work Email'; },
        },
    },
    recommendations: {
        groupOrder: {
            title: function () { return 'Group Order'; },
            subtitle: function () {
                return 'Employees individually choose their items, the order arrives as single delivery';
            },
            whyGroupOrder: function () { return 'Why Group Order'; },
            whyDescription1: function () { return 'Shareable links to quickly add items'; },
            whyDescription2: function () { return 'Lower fees per employee'; },
            whyDescription3: function () { return 'Reduce food waste'; },
            ctaText: function () { return 'Order Now'; },
            modalCtaText: function () { return 'How to Place a Group Order'; },
        },
        catering: {
            title: function () { return 'Catering'; },
            subtitle: function () {
                return 'Schedule a large order for your next team meeting or event';
            },
            whyCatering: function () { return 'Why Catering'; },
            whyDescription1: function () { return 'Easily feed your whole team'; },
            whyDescription2: function () { return 'Highest quality delivery experience'; },
            whyDescription3: function () { return 'Complimentary VIP support'; },
            ctaText: function () { return 'Order Now'; },
        },
        expensedMeals: {
            title: function () { return 'Expensed Meals'; },
            subtitle: function () { return 'Give your team allowance to spend on DoorDash'; },
            whyExpensedMeals: function () { return 'Why Expensed Meals'; },
            whyDescription1: function () { return 'Great for distributed workforces'; },
            whyDescription2: function () { return 'Only pay for what employees order'; },
            whyDescription3: function () { return 'Highly customizable'; },
            ctaText: function () { return 'Get Started For Free'; },
        },
        howToPlaceOrderModal: {
            title: function () { return 'How to place a Group Order'; },
            step1: function () { return 'Find a store that you would like to order from'; },
            step2: function () { return 'Tap on the Group Order button to start a group order'; },
            step3: function () {
                return 'Set a per person limit if needed, and start the group order';
            },
            step4: function () {
                return 'Copy link and share it with the team. Ask them to their favorite food';
            },
            step5: function () { return 'Check out your group cart and enjoy your meal together'; },
            primaryActionText: function () { return 'Continue to Order'; },
            secondaryActionText: function () { return 'Go Back'; },
        },
    },
};
